import { render } from "./AppFooter.vue?vue&type=template&id=065ef592&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=065ef592&scoped=true&lang=css"

import exportComponent from "/Users/danielseguin/Documents/Websites/ootp-calculator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065ef592"]])

export default __exports__